<template>
  <div class="p-secure">
    <div class="p-block">
      <div class="p-block-title">
        <p class="main">{{ baseData.title }}</p>
        <p class="sub">{{ baseData.subtitle }}</p>
      </div>
    </div>
    <ul class="one">
      <li v-for="(item, index) in baseData.list" :index="index" :key="index">
        <p>
          <img :src="item.icon" />
        </p>
        <p>{{ item.name }}</p>
        <p>{{ item.desc }}</p>
        <p>
          <KdIcon
            icon="ShieldColorful"
            :size="18"
            fill="currentColor"
            margin="0 3px 0 0"
            :rightText="item.tag"
            textSize="18"
          ></KdIcon>
        </p>
      </li>
    </ul>
    <ul class="two"></ul>
  </div>
</template>

<script>
import { secureData } from '@/views/homeV2/config.js';
import KdIcon from '@/components/KdIcon/index.vue';
export default {
  name: 'secure-component',
  components: { KdIcon },
  data() {
    return {
      baseData: secureData,
    };
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.p-secure {
  position: relative;
  > ul.one {
    margin-top: 40px;
    li {
      width: 282px;
      height: 332px;
      border-radius: 12px;
      border-width: 1px;
      padding: 40px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      box-shadow: 0px 4px 20px 0px rgba(13, 13, 13, 0.03);
      margin-bottom: 24px;
      margin-right: 24px;
      display: inline-block;
      vertical-align: middle;
      &:last-child {
        margin-right: 0;
      }

      p:nth-child(1) {
        img {
          width: 80px;
          height: 80px;
        }
      }
      p:nth-child(2) {
        margin-top: 24px;
        font-weight: 600;
        font-size: 24px;
        line-height: 38px;
        color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
      }
      p:nth-child(3) {
        margin-top: 8px;
        font-weight: 400;
        font-size: 16px;
        line-height: 160%;
        height: 52px;
        color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
      }
      p:nth-child(4) {
        margin-top: 24px;
        font-size: 16px;
        line-height: 160%;
        color: var(--kd-color-text-secondary, rgba(13, 13, 13, 0.66));
        > label {
          justify-content: left;
          cursor: default;
          :deep(.target) {
            color: rgba(65, 143, 31, 1);
          }
        }
      }
    }
  }
  > ul.two {
    margin-top: 36px;
    background-image: url('@/assets/images/home/secure/safe.png');
    background-repeat: no-repeat;
    background-size: 100%;
    width: 100%;
    height: 100px;
  }
  @include responsiveV2($width-m) {
    > ul.one {
      width: 840px;
      margin: 40px auto 0 auto;
      text-align: center;
      li {
        text-align: left;
        width: 376px;
        padding: 40px;
        box-sizing: border-box;
        &:nth-child(2n) {
          margin-right: 0 !important;
        }
      }
    }
    > ul.two {
      background-image: url('@/assets/images/home/secure/safe-2.png');
      background-size: contain;
      background-position: center;
      width: 100%;
      height: 184px;
    }
  }
}
</style>
